import { useQuery } from 'react-query'
import { fetchProfileStatus } from '../apis/api.signup'

export const useProfileStatus = (profileId: string) => {
    return useQuery({
        queryKey: ['Profile', 'Status', profileId],
        queryFn: () => fetchProfileStatus(profileId),
        enabled: !!profileId,
        staleTime: 5 * 60 * 1000, // 5 minutes
    })
}
